import Vue from 'vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import i18n from './plugins/i18n'
import App from './components/App'
import '~/../sass/app.scss'
import './plugins'
import './components'
import { init as initAmplitude, log } from "./plugins/amplitude"
import { init as initSentry } from "./plugins/sentry"
import {addDirectives} from "./plugins/directives";
import LoadScript from 'vue-plugin-load-script';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
initAmplitude()
initSentry(Vue)
addDirectives(Vue)
Vue.use(LoadScript);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  vuetify,
  render: h => h(App)
})
